import { API_BASE } from '@/Module/Core/Constant';

export const HOME_API = {
  GET_LESSON_LIST_BY_CATEGORY_ID: `${API_BASE}/Lesson/GetRandomLessonByCategoryCategoryId`,
};
